import { ProgressClock } from "./progress-clock";
const template = document.createElement("template");
template.innerHTML = `
	<ol id="clocklist" class="clocklist">
	</ol>
	<form id="createClock">
		<h1>Create New Clock</h1>
		<div>
			<label labelFor="clockName">
				Clock Name
			</label>
			<input type="text" id="clockName" />
		</div>
		<div>
			<label labelFor="clockSegments">
				Segments
			</label>
			<input type="number" id="clockSegments"/>
		</div>
		<button type="submit">Create Clock</button>
	</form>
`;
const style = document.createElement("style");
style.textContent = `
	.clocklist {
		list-style: none;
		padding: 0;
		margin: 0;
	}
`;
export class ProgressClockList extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: "open" });
        shadow.appendChild(style.cloneNode(true));
        shadow.appendChild(template.content.cloneNode(true));
        for (let x = 0; x < 3; x++) {
            const title = `Clock ${x}`;
            const clock = new ProgressClock(title, 8, x);
            this.addClock(clock);
        }
        const form = shadow.getElementById("createClock");
        form.addEventListener("submit", this.HandleCreateClockFormSubmit.bind(this), false);
    }
    static GetFormFieldValue(shadowRoot, id) {
        return shadowRoot.getElementById(id).value;
    }
    attributeChangedCallback() {
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
    HandleCreateClockFormSubmit(event) {
        if (this.shadowRoot === null) {
            throw new Error("Shadow Root cannot be null");
        }
        event.preventDefault();
        const title = ProgressClockList.GetFormFieldValue(this.shadowRoot, "clockName");
        const segmentCount = Number.parseInt(ProgressClockList.GetFormFieldValue(this.shadowRoot, "clockSegments"), 10);
        const clock = new ProgressClock(title, segmentCount, 0);
        this.addClock(clock);
        return false;
    }
    HandleRemoveClick(event) {
        if (this.shadowRoot === null) {
            throw new Error("Shadow Root cannot be null");
        }
        const eventParent = event.target.parentElement;
        const clockList = this.shadowRoot.getElementById("clocklist");
        event.target.removeEventListener("pointerup", this.HandleRemoveClick);
        clockList.removeChild(eventParent);
    }
    addClock(clock) {
        if (this.shadowRoot === null) {
            throw new Error("Shadow Root cannot be null");
        }
        const clockList = this.shadowRoot.getElementById("clocklist");
        const li = document.createElement("li");
        const removeButton = document.createElement("button");
        removeButton.innerText = "X";
        removeButton.addEventListener("pointerup", this.HandleRemoveClick.bind(this), false);
        li.appendChild(clock);
        li.appendChild(removeButton);
        clockList.appendChild(li);
    }
}
customElements.define("v-progress-clock-list", ProgressClockList);
//# sourceMappingURL=progress-clock-list.js.map